module.exports = __webpack_public_path__ + "static/media/time_3600.2ef583cb.png";